module.exports = __webpack_public_path__ + "5ba0e30c94d273471601a7563d18b58b.pdf";